import { render, staticRenderFns } from "./StockMovementListTable.vue?vue&type=template&id=507ed7a6&"
import script from "./StockMovementListTable.vue?vue&type=script&lang=js&"
export * from "./StockMovementListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports